import { render } from "./NameBubble.vue?vue&type=template&id=59618cdc"
import script from "./NameBubble.vue?vue&type=script&lang=js"
export * from "./NameBubble.vue?vue&type=script&lang=js"

import "./NameBubble.vue?vue&type=style&index=0&id=59618cdc&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__